import React, { useState } from "react";
import "./Home.css";
import MiddleSection from "../../components/MiddleSection/MiddleSection";
import Footer from "../../components/Footer/Footer";

const Home = () => {
  const [filters, setFilters] = useState({});

  return (
    <div>
      <MiddleSection />
      <Footer />
    </div>
  );
};

export default Home;
